<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
    <vue-cookie-accept-decline
      :debug="false"
      :disableDecline="false"
      :showPostponeButton="false"
      @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline"
      @clicked-postpone="cookieClickedPostpone"
      @removed-cookie="cookieRemovedCookie"
      @status="cookieStatus"
      elementId="myPanel1"
      position="bottom"
      ref="myPanel1"
      transitionName="fade"
      type="bar"
    >
      <template #postponeContent>&times;</template>
      <template #message>
        We use cookies to ensure you get the best experience on our website. By using this site, you consent to cookies. <a href="#/privacy-policy">Learn more</a>
      </template>
      <template #declineContent>Decline</template>
      <template #acceptContent style="accept">Accept</template>
    </vue-cookie-accept-decline>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";

export default {
  components: {
    FadeTransition,
    VueCookieAcceptDecline,
  },
};
</script>

<style>

</style>
